import { Autocomplete, Box, TextField } from "@mui/material";
import { useEffect, useState } from "react";
// import WorkIcon from '@mui/icons-material/Work';
import { ExpFilterOptions } from "../../Constants";

function FilterByExp({ value, onChecked }) {
  const [inputValue, setInputValue] = useState("");

  // Use ExpFilterOptions from Constants without the "all" option
  const experienceOptions = ExpFilterOptions;

  // Find the matching option based on value
  const selectedOption = value
    ? experienceOptions.find((opt) => {
        if (typeof value === "object" && value !== null) {
          return opt.value === value.value;
        }
        if (typeof value === "number") {
          return opt.value === value;
        }
        return opt.value === value || opt.label === value;
      })
    : null; // No default selection

  const handleChange = (event, newValue) => {
    // Pass the value directly to the parent component
    onChecked(newValue);
  };

  return (
    <Autocomplete
      onChange={handleChange}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      getOptionLabel={(option) => {
        if (typeof option === "string") {
          return option;
        }
        return option.label || "";
      }}
      isOptionEqualToValue={(option, value) => {
        if (!value) return false;
        if (typeof value === "string") {
          return option.value === value || option.label === value;
        }
        if (typeof value === "object" && value !== null) {
          return option.value === value.value;
        }
        return option.value === value;
      }}
      sx={{
        flex: 1,
        minWidth: { md: "300px" },
        "& .MuiOutlinedInput-root": {
          "&:hover": {
            "& > fieldset": {
              borderColor: "primary.main"
            }
          }
        }
      }}
      size="small"
      value={selectedOption}
      options={experienceOptions}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          {/* <WorkIcon sx={{ mr: 1, color: 'primary.main' }} /> */}
          {option.label}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Experience Level"
          placeholder="Select experience range"
        />
      )}
      clearOnBlur
      handleHomeEndKeys
      selectOnFocus
    />
  );
}

export default FilterByExp;
